<template>
  <div class="box-circle-counter">
    <p>{{ title }}</p>
    <v-img
      :style="{
        backgroundColor: color,
        borderRadius: '50%',
        maxHeight: '50px',
        maxWidth: '50px',
      }"
    >
      <p style="margin-top: 15px; color: white">
        {{ count }}
      </p>
    </v-img>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#b97182',
    },
    count: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped>
.box-circle-counter > div {
  margin-right: auto;
  margin-left: auto;
}
.box-circle-counter p {
  text-align: center;
  font-weight: 600;
}
</style>
